import React, { useState, useRef, useEffect } from "react";
import UserBox from "./UserBox";
import LangBox from "./LangBox";
import LogoBox from "./LogoBox";
import MobileDrawer from "./MobileDrawer";
import NavUserBox from "./NavUserBox";
import { Link } from "react-router-dom";
import { Translation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { gameAction } from "_actions";
import { SiteFeatures } from "config/siteFeatures";
import Emitter from "_actions/emitter";
import { FaWhatsapp } from "react-icons/fa";

function MobileNavbar(props) {
  const [showSub, setShowSub] = useState(true);
  const menuContainerRef = useRef(null);
  const location = useLocation();


  const whatsappNumber = '+9647505996005'; // Buraya WhatsApp numaranızı girin

  const cleanWhatsAppNumber = whatsappNumber
    .replace(/^\+?0*/, "")
    .replace(/\D/g, "");

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${cleanWhatsAppNumber}`, "_blank");
  };

  // Aktif sayfayı belirlemek için path kontrolü
  const getActivePath = () => {
    const path = location.pathname;
    if (path.includes("/sports")) return "/sports";
    if (path.includes("/casino")) return "/casino";
    if (path.includes("/live-casino")) return "/live-casino";
    if (path.includes("/games")) return "/games";
    if (path.includes("/virtual")) return "/virtual";
    if (path.includes("/tv-games")) return "/tv-games";
    return path;
  };

  const activePath = getActivePath();

  // Menü öğelerini oluşturmak için yardımcı fonksiyon
  const createMenuItems = (t) => {
    const items = [];

    if (
      (!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) ||
      props.permissions?.SPORTS_ACCESS?.Value
    ) {
      items.push({
        path: "/sports",
        label: t("TITLE_SPORTS"),
        isActive: activePath === "/sports",
      });
    }

    if (
      (!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) ||
      props.permissions?.CASINO_ACCESS?.Value
    ) {
      items.push({
        path: "/casino",
        label: t("TITLE_CASINO"),
        isActive: activePath === "/casino",
      });
    }

    if (
      (!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) ||
      props.permissions?.LIVECASINO_ACCESS?.Value
    ) {
      items.push({
        path: "/live-casino",
        label: t("TITLE_LIVECASINO"),
        isActive: activePath === "/live-casino",
      });
    }

    if (
      (!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) ||
      props.permissions?.GAMES_ACCESS?.Value
    ) {
      items.push({
        path: "/games",
        label: t("TITLE_GAMES"),
        isActive: activePath === "/games",
      });
    }

    if (
      (!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) ||
      props.permissions?.VIRTUAL_ACCESS?.Value
    ) {
      items.push({
        path: "/virtual",
        label: t("TITLE_VIRTUAL"),
        isActive: activePath === "/virtual",
      });
    }

    if (
      (!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) ||
      props.permissions?.TVGAMES_ACCESS?.Value
    ) {
      items.push({
        path: "/tv-games",
        label: t("TITLE_TVGAMES"),
        isActive: activePath === "/tv-games",
      });
    }

    if (false&&SiteFeatures.BONUS_SYSTEM) {
      items.push({
        path: "/bonus",
        label: t("TITLE_BONUS"),
        isActive: activePath === "/bonus",
      });
    }

    items.push({
      path: "/rules",
      label: t("TITLE_RULES"),
      isActive: activePath === "/rules",
    });

    return items;
  };

  // Aktif menü öğesini solda sabit tutmak için scroll pozisyonunu ayarla
  useEffect(() => {
    if (menuContainerRef.current) {
      const activeElement =
        menuContainerRef.current.querySelector(".menu-item-active");
      if (activeElement) {
        const elementLeft = activeElement.offsetLeft;

        // Aktif öğeyi her zaman solda sabit tut (20px padding ile)
        const targetScrollLeft = elementLeft - 20;

        menuContainerRef.current.scrollTo({
          left: Math.max(0, targetScrollLeft),
          behavior: "smooth",
        });
      }
    }
  }, [activePath]);

  const adjustHeight = () => {
    try {
      const navbarHeight = document.querySelector(".base-nav")?.offsetHeight;
      const navbarHeight1 = document.querySelector(".base-nav1")?.offsetHeight;
      const windowHeight = window.innerHeight;
      const pickElement = document.getElementById("pick777");

      if (pickElement) {
        pickElement.style.top = `${
          navbarHeight > navbarHeight1 ? navbarHeight : navbarHeight1
        }px`;
        pickElement.style.height = `${
          windowHeight -
          (navbarHeight > navbarHeight1 ? navbarHeight : navbarHeight1)
        }px`;
      }
    } catch (error) {}
  };

  return (
    <Translation>
      {(t) => {
        const menuItems = createMenuItems(t);

        return (
          <div className="base-nav1 mobile-show bg-secondary-500 flex-col drop-shadow-2xl text-base-content top-0 z-40 flex w-full justify-center bg-opacity-90 backdrop-blur transition-shadow duration-100 [transform:translate3d(0,0,0)] shadow-xl bg-contain bgpattern fixed">
            <nav className="navbar w-full min-h-[40px] h-[40px]">
              <div className="gap-1 flex-1">
                     <MobileDrawer />
              </div>
              <div className="flex flex-1 md:gap-1 lg:gap-2 justify-center">
                <LogoBox />
              </div>
              <div className="flex-1 gap-1 justify-end">
                <button
                  onClick={handleWhatsAppClick}
                  className="flex items-center justify-center w-6 h-6 text-white bg-[#25D366] hover:opacity-90 rounded-md transition-opacity duration-200 p-1"
                  aria-label="WhatsApp"
                >
                  <FaWhatsapp className="text-2xl" />
                </button>
                {!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn && (
                  <div
                    className="shrink-0 mr-4 btn-xs	text-white btn btn-ghost bg-primary-400/50 bg-transparent uppercase"
                    onClick={() => {
                      Emitter.emit("LOGIN_MODAL", true);
                    }}
                  >
                    {t("BUTTON_SIGNIN")}
                  </div>
                )}
                {props.loggedIn && <NavUserBox />}

                {/*
                   <div
                    style={{
                      background: "transparent",
                      border: "none",
                    }}
                    className="btn btn-neutral btn-sm btn-square"
                    onClick={() => {
                      setShowSub(!showSub);
                      setTimeout(() => {
                        adjustHeight();
                      }, 200);
                    }}
                  >
                    {showSub ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m4.5 15.75 7.5-7.5 7.5 7.5"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m19.5 8.25-7.5 7.5-7.5-7.5"
                        />
                      </svg>
                    )}
                  </div>
                  */}
             
              </div>
            </nav>
            {showSub && (
              <div
                ref={menuContainerRef}
                className="flex items-center bg-secondary-500 border-b-1 border-secondary-50 border-b border-solid w-full overflow-x-auto scrollbar-hide menu-container"
                style={{
                  scrollBehavior: "smooth",
                  touchAction: "pan-x",
                }}
              >
                <div className="flex items-center min-w-max px-2 relative">
                  {menuItems.map((item, index) => (
                    <div key={index} className="flex-shrink-0 ">
                      <Link
                        to={item.path}
                        className={`menu-item px-3 py-2 text-xs uppercase font-medium transition-all duration-200 ${
                          item.isActive
                            ? "menu-item-active text-white border-b-1 border-secondary-50"
                            : "text-white text-opacity-50"
                        }`}
                        style={{
                          whiteSpace: "nowrap",
                          textDecoration: "none",
                          fontSize: "10px",
                          letterSpacing: "0.065em",
                        }}
                      >
                        {item.label}
                      </Link>
                    </div>
                  ))}
                  {props.loggedIn && SiteFeatures.DEPOSIT_SYSTEM && (
                    <div className="flex-shrink-0">
                      <div
                        onClick={() => Emitter.emit("BALANCE_MODAL", "deposit")}
                        className="menu-item px-3 py-2 text-xs uppercase font-medium text-primary-400 cursor-pointer"
                        style={{
                          whiteSpace: "nowrap",
                          fontSize: "10px",
                          letterSpacing: "0.065em",
                        }}
                      >
                        + {t("BALANCE_MODAL_DEPOSIT_BUTTON")}
                      </div>
                    </div>
                  )}
                  {props.loggedIn && SiteFeatures.DEPOSIT_SYSTEM && (
                    <div className="flex-shrink-0">
                      <div
                        onClick={() =>
                          Emitter.emit("BALANCE_MODAL", "withdraw")
                        }
                        className="menu-item px-3 py-2 text-xs uppercase font-medium text-white text-opacity-70 cursor-pointer"
                        style={{
                          whiteSpace: "nowrap",
                          fontSize: "10px",
                          letterSpacing: "0.065em",
                        }}
                      >
                        − {t("BALANCE_MODAL_WITHDRAW_BUTTON")}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        );
      }}
    </Translation>
  );
}
const mapStateToProps = (state, props) => {
  const { authentication } = state;
  const { user, loggedIn, permissions } = authentication;

  return {
    user,
    loggedIn,
    permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateGames: (data) => dispatch(gameAction.UpdateGamesData(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MobileNavbar);

/*
bg-gradient-to-r from-primary-600 via-primary-500 to-primary-600

*/
